import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "source", "filterable", "select" ]

  filter(event) {
    const filterTerm = this.hasSourceTarget ? this.sourceTarget.value.toLowerCase() : "";

    const filterSelects = this.hasSelectTarget
      ? this.selectTargets.map(select => select.value.toLowerCase()).filter(Boolean)
      : [];

    this.filterableTargets.forEach((el) => {
      const filterableKey = (el.dataset.filterKey || "").toLowerCase();
      const matchesTerm = !filterTerm || filterableKey.includes(filterTerm);
      const matchesSelects = filterSelects.every(selectValue => filterableKey.includes(selectValue));

      el.classList.toggle("notvisible", !(matchesTerm && matchesSelects));
    });
  }

}
